export const environment = {
  production: true,
  cryptoSecretKey: '4E123F0CAB2A87D9F86E41C8A93B4D72',
  gCaptchaKey: '6LemCwkoAAAAANUF-YUKgxNVjViaQB69klAyM8ZX',
  firebase: {
    apiKey: "AIzaSyBUgY3agJdFGFdGixUlFizLiU7vywq_sSA",
    authDomain: "memship-bd693.firebaseapp.com",
    projectId: "memship-bd693",
    storageBucket: "memship-bd693.firebasestorage.app",
    messagingSenderId: "723291407368",
    appId: "1:723291407368:web:027bddc0cd3d006ce1fdbd",
    measurementId: "G-9BNPH6VDEG"
  }
};
